<div class="logs-header align-items-end">
  <h3><i class="fas fa-plug"></i> Integrations</h3>
</div>

<app-loading-spinner
  *ngIf="integrationsLoading; else content"
  size="md"
></app-loading-spinner>

<ng-template #content>
  <app-table>
    <app-table-headers>
      <app-table-header>Integration</app-table-header>
      <app-table-header>Sections</app-table-header>
    </app-table-headers>

    <ng-template #empty>
      <app-table-content-empty>
        <ng-container nodata
          ><p>No installed integrations on this account</p></ng-container
        >
      </app-table-content-empty>
    </ng-template>

    <app-table-content *ngIf="integrations.length; else empty">
      <app-table-row *ngFor="let integration of integrations">
        <app-table-cell>{{ integration.id }}</app-table-cell>
        <app-table-cell>{{ integration.sections.join(', ') }}</app-table-cell>
      </app-table-row>
    </app-table-content>
  </app-table>
</ng-template>
